import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'intro',
    pathMatch: 'full'
  },

  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then( m => m.IntroPageModule)
  },

  {
    path: 'sesion',
    loadChildren: () => import('./sesion/sesion.module').then( m => m.SesionPageModule)
  },

  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },

  {
    path: 'chagual',
    loadChildren: () => import('./chagual/chagual.module').then( m => m.ChagualPageModule)
  },

  {
    path: 'acerca',
    loadChildren: () => import('./acerca/acerca.module').then( m => m.AcercaPageModule)
  },

  {
    path: 'mapappal',
    loadChildren: () => import('./mapappal/mapappal.module').then( m => m.MapappalPageModule)
  },

   {
    path: 'recursos',
    loadChildren: () => import('./recursos/recursos.module').then( m => m.RecursosPageModule)
  },

  {
    path: 'integrar',
    loadChildren: () => import('./integrar/integrar.module').then( m => m.IntegrarPageModule)
  },

  {
    path: 'explorar',
    loadChildren: () => import('./explorar/explorar.module').then( m => m.ExplorarPageModule)
  },

  {
    path: 'comunidad',
    loadChildren: () => import('./comunidad/comunidad.module').then(m => m.ComunidadPageModule),
    canActivate: [AuthGuard],  // Proteger con autenticación
    data: { tipoUsuario: 'organizacion' }
  },

   {
    path: 'diariomural',
    loadChildren: () => import('./diariomural/diariomural.module').then( m => m.DiariomuralPageModule)
  },

  {
    path: 'seccion-detalle/:id',
    loadChildren: () => import('./seccion-detalle/seccion-detalle.module').then(m => m.SeccionDetallePageModule),
    canActivate: [AuthGuard]  // Proteger con autenticación
  },

  {
    path: 'articulo2/:id',
    loadChildren: () => import('./articulo2/articulo2.module').then( m => m.Articulo2PageModule)
  },
  
  {
  path: 'sala-detalle/:id',
  loadChildren: () => import('./sala-detalle/sala-detalle.module').then( m => m.SalaDetallePageModule),
  canActivate: [AuthGuard]
},
  {
    path: 'perfil',
    loadChildren: () => import('./perfil/perfil.module').then( m => m.PerfilPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
